module.exports = __webpack_public_path__ + "assets/images/Caixa_brincadeiras_a8242e0b9b91a5ba60f66f7fd5f30159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-four/Caixa_brincadeiras.png
// module id = 215
// module chunks = 0